class ProductQuickAdd extends HTMLElement {
  constructor() {
    super();
  }

  variantChangeUnsubscriber = undefined;

  connectedCallback() {
    this.currentScrollTop = 0;

    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScrollHandler, false);

    this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const {
        variant: { id },
      } = event.data;

      fetch(`${this.productUrl}?section_id=${this.sectionId}${id ? `&variant=${id}` : ''}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const source = html.getElementById(`shopify-section-${this.sectionId}`);

          if (source) {
            this.innerHTML = source.querySelector('product-quick-add').innerHTML;
          }
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            console.log('Fetch aborted by user');
          } else {
            console.error(error);
          }
        });
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);

    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onScroll() {
    const { scrollTop } = document.documentElement;
    const { scrollHeight } = document.body;

    if (scrollTop === window.innerHeight) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop || scrollHeight - window.innerHeight * 2 <= scrollTop) {
      requestAnimationFrame(this.hide.bind(this));
    } else {
      requestAnimationFrame(this.reveal.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.setAttribute('aria-hidden', 'true');
  }

  reveal() {
    this.removeAttribute('aria-hidden');
  }

  get sectionId() {
    return this.dataset.section;
  }

  get productUrl() {
    return this.dataset.productUrl;
  }
}

customElements.define('product-quick-add', ProductQuickAdd);
